const categoryFilter = document.querySelector('.category-filter');

if (categoryFilter) {
    categoryFilter.addEventListener('change', (e) => {
        const option = e.target.selectedOptions[0];
        const { link } = option.dataset;
        if (link) window.location.href = link;
    });
}
